


















































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import { getTimeSince } from "@/utils/date-helpers";
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";
import difficulties from "@/config/wow/difficulties";

/**
 * Character wishes tooltip content component.
 */
@Component
export default class WishesTooltipContent extends Vue {
	/// Injections
	getTimeSince = getTimeSince;
	imageLinks = imageLinks;
	classes = classes;
	difficulties = difficulties;

	@Prop()
	character!: any;
}
